/**
 * Card rules and configuration constants
 */

// Custom card rules: card numbers with copy limits exceeding 4
export const CARD_RULES = {
  'PR-107': 8,    // Exception: Baltan can have up to 8 copies
  'PR-036': 50    // Exception: can have up to 50 copies
};

// Preloaded deck templates
// To add more decks: add an entry with a unique id, name, description, 
// representative imageUrl (first card image), and the deckCode (base64 export string)
export const PRELOAD_DECKS = [
  {
    id: 'ud01-starter',
    name: 'Tiga Blazar Ultra Deck Demo',
    description: 'A balanced Ultraman Tiga Blazar Ultra deck for beginners as a possible upgrade for your UD01 Decks.',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/f890742dcca77afa.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI1LTEyLTI5VDAyOjQxOjU5LjYwMFoiLCJjYXJkcyI6W3siaWQiOiIyNjciLCJjb3VudCI6M30seyJpZCI6IjExNCIsImNvdW50Ijo0fSx7ImlkIjoiMzYiLCJjb3VudCI6M30seyJpZCI6IjM5IiwiY291bnQiOjJ9LHsiaWQiOiI5MzEiLCJjb3VudCI6Mn0seyJpZCI6IjkzNCIsImNvdW50IjoyfSx7ImlkIjoiOTAxIiwiY291bnQiOjJ9LHsiaWQiOiI3NjUiLCJjb3VudCI6NH0seyJpZCI6Ijc2OSIsImNvdW50IjozfSx7ImlkIjoiMTYiLCJjb3VudCI6NH0seyJpZCI6IjkzIiwiY291bnQiOjR9LHsiaWQiOiI5NCIsImNvdW50Ijo0fSx7ImlkIjoiMjIiLCJjb3VudCI6MX0seyJpZCI6IjY2IiwiY291bnQiOjF9LHsiaWQiOiI5MjciLCJjb3VudCI6NH0seyJpZCI6IjkyOSIsImNvdW50IjozfSx7ImlkIjoiNjIiLCJjb3VudCI6NH1dfQ==' // Paste exported deck code here
  },
  {
    id: 'gardeno-geed',
    name: 'Anti Kaiju Geed',
    description: 'A Mono-Geed deck focused on anti-Kaiju strategies to face off against Omega and other Kaiju decks.',
    imageUrl: 'https://gardenostorage.blob.core.windows.net/ultraman-cards/full/0b74547713e9aedd.png',
    deckCode: 'eyJ2ZXJzaW9uIjoyLCJ0aW1lc3RhbXAiOiIyMDI1LTEyLTI5VDAyOjUzOjIxLjMyN1oiLCJjYXJkcyI6W3siaWQiOiI4NDMiLCJjb3VudCI6NH0seyJpZCI6IjkwMyIsImNvdW50IjoyfSx7ImlkIjoiNjc2IiwiY291bnQiOjR9LHsiaWQiOiI0NDEiLCJjb3VudCI6NH0seyJpZCI6IjQ0MiIsImNvdW50Ijo0fSx7ImlkIjoiNTQiLCJjb3VudCI6NH0seyJpZCI6IjEyNCIsImNvdW50Ijo0fSx7ImlkIjoiNzQiLCJjb3VudCI6NH0seyJpZCI6IjgzOCIsImNvdW50Ijo0fSx7ImlkIjoiMTU2IiwiY291bnQiOjR9LHsiaWQiOiI5MDgiLCJjb3VudCI6Mn0seyJpZCI6IjY3NSIsImNvdW50Ijo0fSx7ImlkIjoiMTI3IiwiY291bnQiOjR9LHsiaWQiOiIzMjEiLCJjb3VudCI6Mn1dfQ=='
  }
  // Add more decks here following the same format
];

// Chart options for deck statistics
export const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        font: { size: 11 },
        padding: 10,
        usePointStyle: true,
      }
    }
  }
};

// Base bar chart options - max will be set dynamically
export const BAR_CHART_OPTIONS = {
  indexAxis: 'x',
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    }
  },
  scales: {
    y: {
      beginAtZero: true,
      max: 20, // Default, will be overridden dynamically
      ticks: { stepSize: 5 }
    }
  }
};

// Helper to get dynamic bar chart options based on max count
export const getBarChartOptions = (maxCount) => {
  let yMax = 20;
  let stepSize = 5;
  
  if (maxCount > 20) {
    yMax = 30;
    stepSize = 5;
  }
  
  return {
    ...BAR_CHART_OPTIONS,
    scales: {
      y: {
        beginAtZero: true,
        max: yMax,
        ticks: { stepSize }
      }
    }
  };
};

// Color palette for pie chart
export const CHART_COLORS = [
  '#3c618a', '#7a67ba', '#dc143c', '#ff6b9d', '#ffa500',
  '#51cf66', '#339af0', '#845ef7', '#d0bfff', '#ffd43b',
  '#ff922b', '#fa5252', '#748ffc', '#b197fc', '#91a7ff'
];
